import { CalendarDaysIcon } from 'lucide-react'

import { dateToLocaleString } from '@/utilities/dateToLocaleString'

import type { Bill } from '@/payload-types'

type BillAction = NonNullable<NonNullable<Bill['bt50']>['actions']>[number]

/**
 * Bill activity history. Each row shows the action date above its description.
 */
export const ActivityContent = ({ billActions }: { billActions: BillAction[] }) => {
  return (
    <div className="flex flex-col gap-3">
      {billActions.map((action, index) => (
        <div
          key={action.id ?? `${action.actionDate}-${index}`}
          className="flex flex-col gap-2 rounded-xl border border-border bg-white px-4 py-3 font-body"
        >
          {action.actionDate ? (
            <div className="flex items-center gap-1 text-muted-foreground">
              <CalendarDaysIcon className="size-4" />
              <p className="text-sm font-medium">{dateToLocaleString(action.actionDate)}</p>
            </div>
          ) : null}
          <p
            className="m-0 line-clamp-3 p-0 text-base leading-snug font-semibold text-primary"
            title={action.actionDescription ?? undefined}
          >
            {action.actionDescription}
          </p>
        </div>
      ))}
    </div>
  )
}
